import "./ConsentToggle.css";

const ConsentToggle = ({ label, description, checked, onChange, disabled, lockedLabel }) => (
  <div className={`consent-toggle-row ${disabled ? "consent-toggle-row-locked" : ""}`}>
    <div className="consent-toggle-info">
      <h4>{label}</h4>
      <p>{description}</p>
    </div>
    <div className="consent-toggle-control">
      {disabled && <span className="consent-locked-label">{lockedLabel}</span>}
      <label className={`consent-switch ${disabled ? "consent-switch-disabled" : ""}`}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.checked)}
          aria-label={label}
        />
        <span className="consent-switch-track">
          <span className="consent-switch-thumb" />
        </span>
      </label>
    </div>
  </div>
);

export default ConsentToggle;
